/* =====================================================================
   ZZ Collection Tabs — Tab-Leiste mit Collections, Panels mit Produkten.
   Server-gerendert; JS toggelt nur Sichtbarkeit. Idempotent.
   ===================================================================== */
(function () {
  'use strict';

  function init(root) {
    if (!root || root.__zzCtabsInit) return;
    root.__zzCtabsInit = true;

    var tabs = root.querySelectorAll('[data-zz-tab]');
    var panels = root.querySelectorAll('[data-zz-tab-panel]');
    if (tabs.length < 2) return;

    var animate = document.body.classList.contains('cc-animate-enabled');

    function activate(id) {
      tabs.forEach(function (t) {
        var on = t.getAttribute('data-zz-tab') === id;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      panels.forEach(function (p) {
        var on = p.getAttribute('data-zz-tab-panel') === id;
        p.hidden = !on;
        if (on && animate) {
          // Animation bei jedem Wechsel neu starten
          p.classList.remove('is-animating');
          void p.offsetWidth; // Reflow erzwingen, damit die Keyframes neu laufen
          p.classList.add('is-animating');
        }
      });
    }

    tabs.forEach(function (t) {
      t.addEventListener('click', function () {
        activate(t.getAttribute('data-zz-tab'));
      });
    });
  }

  function boot() {
    document.querySelectorAll('[data-zz-ctabs]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector ? e.target.querySelector('[data-zz-ctabs]') : null;
    if (el) init(el);
  });
})();
